class MenuDrawerGuard {
  constructor() {
    this.hiddenWhatsappWidgets = [];
    this.boundSync = this.sync.bind(this);
    this.boundHandleMutations = this.handleMutations.bind(this);
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.bodyObserver = new MutationObserver(this.boundHandleMutations);
    this.bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    document.addEventListener('click', () => window.setTimeout(this.boundSync, 0));
    document.addEventListener('toggle', this.boundSync, true);
    document.addEventListener('transitionend', this.boundSync, true);
    window.addEventListener('resize', this.boundSync);
    window.addEventListener('orientationchange', this.boundSync);

    this.sync();
  }

  handleMutations(mutations) {
    const shouldSync = mutations.some(
      (mutation) =>
        mutation.type === 'attributes' ||
        mutation.addedNodes.length > 0 ||
        mutation.removedNodes.length > 0
    );

    if (shouldSync) this.sync();
  }

  isMenuDrawerOpen() {
    if (window.innerWidth > 989) return false;

    const primaryDrawer = document.getElementById('Details-menu-drawer-container');
    const openHeaderDrawer = document.querySelector('header-drawer details[open]');
    const openingHeaderDrawer = document.querySelector('header-drawer details.menu-opening');
    const openingContainer = document.querySelector('header-drawer .menu-drawer-container.menu-opening');

    return Boolean((primaryDrawer && primaryDrawer.open) || openHeaderDrawer || openingHeaderDrawer || openingContainer);
  }

  sync() {
    const isOpen = this.isMenuDrawerOpen();

    document.body.classList.toggle('menu-drawer-open', isOpen);
    document.documentElement.classList.toggle('menu-drawer-open', isOpen);

    if (isOpen) {
      this.hideWhatsappWidgets();
    } else {
      this.restoreWhatsappWidgets();
    }
  }

  hideWhatsappWidgets() {
    const hiddenNodes = new Set(this.hiddenWhatsappWidgets.map(({ node }) => node));
    const candidates = Array.from(document.querySelectorAll('body *'));

    candidates.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (hiddenNodes.has(node)) return;
      if (node.closest('header-drawer, menu-drawer, cart-drawer')) return;

      const style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return;

      const fingerprint = [
        node.tagName,
        node.id || '',
        String(node.className || ''),
        node.getAttribute('aria-label') || '',
        node.getAttribute('title') || '',
        node.getAttribute('data-testid') || '',
        node.getAttribute('href') || '',
        node.getAttribute('src') || '',
      ]
        .join(' ')
        .toLowerCase();

      const isWhatsapp = /(whatsapp|whatflow|wa\.me|api\.whatsapp|myshop)/.test(fingerprint);
      if (!isWhatsapp) return;

      const rect = node.getBoundingClientRect();
      const nearEdge =
        rect.left <= 48 ||
        rect.right >= window.innerWidth - 48 ||
        rect.bottom >= window.innerHeight - 48 ||
        rect.top <= 48;
      const isFloating =
        style.position === 'fixed' ||
        style.position === 'sticky' ||
        style.position === 'absolute' ||
        node.tagName === 'IFRAME';

      if (!isFloating && !nearEdge) return;

      this.hiddenWhatsappWidgets.push({
        node,
        display: node.style.display,
        pointerEvents: node.style.pointerEvents,
        opacity: node.style.opacity,
        visibility: node.style.visibility,
      });

      node.style.display = 'none';
      node.style.pointerEvents = 'none';
      node.style.opacity = '0';
      node.style.visibility = 'hidden';
    });
  }

  restoreWhatsappWidgets() {
    if (!this.hiddenWhatsappWidgets.length) return;

    this.hiddenWhatsappWidgets.forEach(({ node, display, pointerEvents, opacity, visibility }) => {
      if (!(node instanceof HTMLElement)) return;
      node.style.display = display;
      node.style.pointerEvents = pointerEvents;
      node.style.opacity = opacity;
      node.style.visibility = visibility;
    });

    this.hiddenWhatsappWidgets = [];
  }
}

if (!window.menuDrawerGuard) {
  window.menuDrawerGuard = new MenuDrawerGuard();
  window.menuDrawerGuard.init();
}
